/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RrpUploadResultResponse } from './RrpUploadResultResponse';
import {
    RrpUploadResultResponseFromJSON,
    RrpUploadResultResponseFromJSONTyped,
    RrpUploadResultResponseToJSON,
    RrpUploadResultResponseToJSONTyped,
} from './RrpUploadResultResponse';
import type { FileProcessResultResponse } from './FileProcessResultResponse';
import {
    FileProcessResultResponseFromJSON,
    FileProcessResultResponseFromJSONTyped,
    FileProcessResultResponseToJSON,
    FileProcessResultResponseToJSONTyped,
} from './FileProcessResultResponse';

/**
 * 
 * @export
 * @interface UploadFileProcessResultResponse
 */
export interface UploadFileProcessResultResponse {
    /**
     * 
     * @type {FileProcessResultResponse}
     * @memberof UploadFileProcessResultResponse
     */
    fileProcessResult: FileProcessResultResponse;
    /**
     * 
     * @type {RrpUploadResultResponse}
     * @memberof UploadFileProcessResultResponse
     */
    uploadResult?: RrpUploadResultResponse;
    /**
     * 
     * @type {number}
     * @memberof UploadFileProcessResultResponse
     */
    rowsAdded?: number | null;
}

/**
 * Check if a given object implements the UploadFileProcessResultResponse interface.
 */
export function instanceOfUploadFileProcessResultResponse(value: object): value is UploadFileProcessResultResponse {
    if (!('fileProcessResult' in value) || value['fileProcessResult'] === undefined) return false;
    return true;
}

export function UploadFileProcessResultResponseFromJSON(json: any): UploadFileProcessResultResponse {
    return UploadFileProcessResultResponseFromJSONTyped(json, false);
}

export function UploadFileProcessResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadFileProcessResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileProcessResult': FileProcessResultResponseFromJSON(json['fileProcessResult']),
        'uploadResult': json['uploadResult'] == null ? undefined : RrpUploadResultResponseFromJSON(json['uploadResult']),
        'rowsAdded': json['rowsAdded'] == null ? undefined : json['rowsAdded'],
    };
}

export function UploadFileProcessResultResponseToJSON(json: any): UploadFileProcessResultResponse {
    return UploadFileProcessResultResponseToJSONTyped(json, false);
}

export function UploadFileProcessResultResponseToJSONTyped(value?: UploadFileProcessResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileProcessResult': FileProcessResultResponseToJSON(value['fileProcessResult']),
        'uploadResult': RrpUploadResultResponseToJSON(value['uploadResult']),
        'rowsAdded': value['rowsAdded'],
    };
}

